// src/firebaseConfig.js
import firebase from "firebase";
import 'firebase/firestore'

// Your web app's Firebase configuration
var firebaseConfig = {
    apiKey: "AIzaSyD-emPSlb98fSfUO_hC1Zyrj7yxkNqXSZ8",
    authDomain: "pedalboard-17e32.firebaseapp.com",
    projectId: "pedalboard-17e32",
    storageBucket: "pedalboard-17e32.appspot.com",
    messagingSenderId: "275761113437",
    appId: "1:275761113437:web:e010ee21d2dfc46768e0b4"
};
firebase.initializeApp(firebaseConfig)

const db = firebase.firestore()
const auth = firebase.auth()
const userCollection = db.collection('users')
const gearCollection = db.collection('gear')
const songCollection = db.collection('songs')
const feedbackCollection = db.collection('feedback')

// Initialize Firebase
//export default firebase.initializeApp(firebaseConfig);
export {
    db,
    auth,
    gearCollection,
    userCollection,
    songCollection,
    feedbackCollection
}

